const keycloakReducer = (state = null, action) => {
  if (action.type === 'SET_KEYCLOAK') {
    return action.payload;
  }
  return state;
};

export default keycloakReducer;
